import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnalytics: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAnalytics"><Path d="M21 3H3V11H8.58032L10 13.4844L14 6.48444L16.5803 11H21V3Z" fill="currentColor"/><Path d="M21 13H15.4197L14 10.5156L10 17.5156L7.41968 13H3V21H21V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnalytics;
